<template>
  <div class="main_home">
    <div>
        <div class="main_header">
            <h1 style="font-size:30px;text-align: center;width: 100%;margin: 0 auto;padding: 0;background: #0072ff;line-height: 70px;color: white;">
                {{ company.name }}
            </h1>
        </div>
        <div class="main_title" style="margin-top:40px;">
            <ul style="overflow:hidden;">
                <li>
                    <el-image fit="cover"  class="main_title_img" :src="require('@/assets/wechat.png')">
                    </el-image>
                </li>
                <li>
                    <span>
                        用户绑定微信
                    </span>
                </li>
            </ul>
        </div>
        <div class="main_content" style="margin-top:50px;">
            <ul style="display:grid;">
                <li style="width:100%;height:70px;">
                    <a-input ref="userNameInput" addon-before="账号" @pressEnter="bind" :placeholder="is_new_user?'请输入账号':'输入用户名 / 邮箱'" v-model="username" size="large" style="width:100%;margin-top:20px;font-size:20px;">
                        <a-icon type="user" />
                    </a-input>
                </li>
                <li style="width:100%;height:70px;" v-if="is_new_user">
                    <a-input addon-before="邮箱" type="email" placeholder="请输入邮箱" @pressEnter="bind" v-model="email" size="large" style="width:100%;margin-top:20px;font-size:20px;">
                        <a-icon type="user" />
                    </a-input>
                </li>
                <li style="width:100%;height:70px;">
                    <a-input-password addon-before="密码" v-model="password" @pressEnter="bind" placeholder="请输入密码" size="large" style="display:block;width:100%;margin-top:20px;font-size:20px;">
                        <a-icon type="user" />
                    </a-input-password>
                </li>
                <li style="width:100%;height:70px;" v-if="is_new_user">
                    <a-input-password addon-before="重新输入密码" v-model="repassword" placeholder="请重新输入密码" size="large" style="width:100%;margin-top:20px;font-size:20px;">
                        <a-icon type="user" />
                    </a-input-password>
                </li>
                <li style="width:100%;height:70px;">
                    <a-form-model-item>
                        <a-button @click="bind" :loading="bind_loading" style="border-radius:5px;background:#1890ff;display:block;width:100%;height:50px;line-height:50px;margin-top:20px;color:white;font-size:20px;text-align:center;">
                            绑定
                        </a-button>
                    </a-form-model-item>
                </li>
                <li style="width:100%;height:70px;">
                    <a-form-model-item>
                        <a v-if="is_new_user==false" @click="is_new_user=true" style="border-radius:5px;color:#1890ff;display:block;width:150px;height:30px;line-height:30px;margin-top:20px;font-size:16px;">
                            我还没有账号
                        </a>
                        <a v-else @click="is_new_user=false" style="border-radius:5px;color:#1890ff;display:block;width:150px;height:30px;line-height:30px;margin-top:20px;font-size:16px;">
                            我已经有账号
                        </a>
                    </a-form-model-item>
                </li>
            </ul>
        </div>
    </div>
    <div class="register_footer">
        <ul style="width:100%;height:100%;">
            <li style="float:left;height:100%;width:40%;margin-left:10%;">
                <router-link to="/home" class="member_home_a">
                    <ul style="text-align:center;">
                        <li>
                            <el-image fit="cover"  class="member_quit_img" :src="require('@/assets/account_login.png')">
                                
                            </el-image>
                        </li>
                        <li>
                            <a class="member_quit_a">
                                会员中心
                            </a>
                        </li>
                    </ul>
                </router-link>
            </li>
            <li style="float:right;height:100%;width:40%;margin-right:10%;">
                <router-link to="/" class="member_home_a">
                    <ul style="text-align:center;">
                        <li>
                            <el-image fit="cover"  class="member_quit_img" :src="require('@/assets/quit.png')">
                                
                            </el-image>
                        </li>
                        <li>
                            <a class="member_quit_a">
                                安全退出
                            </a>
                        </li>
                    </ul>
                </router-link>
            </li>
        </ul>
    </div>
  </div>
</template>

<script>

import request from "../../api/request"
import company_model from '../../model/company'
import watermark from 'watermark-dom'

export default {
    name: 'UserBind',
    head: {
        title: "绑定微信用户",
        meta:[
            { name: 'description', content: '绑定微信用户'}
        ]
    },
    data() {
        return {
            username: undefined,
            email: undefined,
            password: undefined,
            repassword: undefined,
            
            is_new_user: false,
            bind_loading: false,
            company: company_model,
        }
    },
    methods: {
        fetch_company() {
            let company_info_resp = request.company.company()
            company_info_resp.then((response) => {
                if (response.status == 200 && response.data.code == 0) {
                    if (response.data.data) {
                        this.company = response.data.data
                    }
                }
            })
        },
        bind() {
            var success_message = "绑定成功"
            var failed_message = "绑定失败"
            if (this.is_new_user) {
                if (
                !this.username || 
                !this.email || 
                !this.password || 
                !this.repassword
                ) {
                    this.$message.error("用户名，邮箱，密码和重新输入密码必须填写!!!")
                }
                else if (this.password != this.repassword) {
                    this.$message.error("密码和重新输入密码必须一致!!!")
                }
                else {
                    this.bind_loading = true
                    let resp = request.site_user.bind(this.username, this.email, this.password, this.repassword, !this.is_new_user)
                    resp.then((response) => {
                        this.bind_loading = false
                        if (response.status == 200 && response.data.code == 0) {
                            success_message = response.data.message
                            if (!success_message) {
                                success_message = "绑定成功"
                            }
                            this.$message.success(success_message)
                            this.$router.push('/order/list')
                        }
                        else {
                            failed_message = response.data.message
                            if (!failed_message) {
                                failed_message = "绑定失败"
                            }
                            this.$message.error(failed_message)
                        }
                    })
                    .catch((error) => {
                        this.bind_loading = false
                        if (error) {
                            this.$error({
                                title: "请求失败，请联系管理员",
                                content: String(error),
                            });
                        }
                    })
                }
            }
            else {
                if (
                !this.username || 
                !this.password
                ) {
                    this.$message.error("用户名，密码必须填写!!!")
                }
                else {
                    this.bind_loading = true
                    let resp = request.site_user.bind(this.username, this.email, this.password, this.repassword, !this.is_new_user)
                    resp.then((response) => {
                        this.bind_loading = false
                        if (response.status == 200 && response.data.code == 0) {
                            success_message = response.data.message
                            if (!success_message) {
                                success_message = "绑定成功"
                            }
                            this.$message.success(success_message)
                            this.$router.push('/order/list')
                        }
                        else {
                            failed_message = response.data.message
                            if (!failed_message) {
                                failed_message = "绑定失败"
                            }
                            this.$message.error(failed_message)
                        }
                    })
                    .catch((error) => {
                        this.bind_loading = false
                        if (error) {
                            this.$error({
                                title: "请求失败，请联系管理员",
                                content: String(error),
                            });
                        }
                    })
                }
            }
        },
        load() {
            try {
                watermark.remove()
            }
            catch (err) {
                console.log()
            }
            this.fetch_company()
        }
    },
    created() {
        this.load()
    },
    components: {

    }
}
</script>

<style>

html {
  margin: 0;
  padding: 0;
}

body {
  margin: 0; 
  padding: 0;
}

ul {
  list-style: none;
}

.main_home {
  height: 100%;
  margin: 0;
  padding: 0;
}

.main_header {
    text-align: center;
    width: 100%;
    margin: 0 auto;
    padding: 0;
}

.main_title {
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 20px;
    height: 50px;
}

.main_title ul {
    margin: 0 auto;
    padding: 0;
    height: 100%;
}


.main_title ul li {
    height: 100%;
    margin: 0 auto;
    padding: 0;
    float: left;
}

.main_title ul li:last-child {
    margin-left: 20px;
}

.main_title_img {
    width: 50px;
    height: 50px;
}

.main_title ul > li > span {
    display: block;
    margin: 0 auto;
    padding: 0;
    line-height: 50px;
    font-size: 20px;
}


.main_content > ul {
    margin: 0;
    padding: 0;
    height: 310px;
}

.register_footer {
   position: fixed;
   left: 0;
   width: 100%;
   background-color: #99999955;
   color: white;
   bottom: 0;
   text-align: center;
   height:100px;
}

.register_footer ul {
    padding: 0;
    margin: 0 auto;
    width: 100%;
    height: 100%;
}

.register_footer ul li {
    width: 100%;
    list-style: none;
}

.register_footer ul li:first-child {
    width: 100%;
    height: 60px;
    margin: 0 auto;
}

.register_footer ul li:last-child {
    height: 40px;
}

.member_quit_img {
    width: 50px;
    height: 50px;
    margin: 0 auto;
    margin-top: 10px;
}

.member_quit_a {
    width: 100%;
    height: 40px;
    line-height: 40px;
    display: block;
    text-align: center;
    margin: 0 auto;
    color: #999;
}

</style>
